export class HtmlEditorCkLazyComponentDefinition {

  static getDefinition() {
    return {
      module: () => import('../ck.module').then(m => m.CkModule),
      component: () => import('./html-editor-ck.component').then(m => m.HtmlEditorCkComponent),
    };
  }
}
